module.exports = __webpack_public_path__ + "static/media/pic3.571ae4a0.jpg";